<template>
  <div>
    <div style="margin-left: 250px;">
       <el-card>
        <el-card style="margin-bottom: 30px;">课消详情 （老师统计） <i style="position: absolute;right: 60px;font-size: 25px;color: #409EFF;"
           class="el-icon-circle-close" @click="handleReturn"></i></el-card>

        <el-form style="display: flex;flex-wrap: wrap;"  >


              <el-form-item label="课程:" style="display: flex;width: 33%; ">
                <div style=" padding-left: 27px;">
                  <el-select
                    placeholder="请选择课程"
                    v-model="curriculum"
                    style="width: 100%;"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in optionList4"
                      :key="item.id"
                      :value="item.id"
                      :label="item.categoryName"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>

              <el-form-item label="线下学员:" style="display: flex;width: 33%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="规划学员:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择学员"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="学生类型:" style="width: 33%; display: flex;">
                <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                  <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
                </el-select>
              </el-form-item>


              <!-- <el-form-item label="课消状态:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择课消状态"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in coursecancellationStatus"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->


              <el-form-item label="上课方式:" style="display: flex;width: 33%;" >
                <el-select
                  placeholder="请选择上课方式"
                  v-model="coursecancellationStatusInputs"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in coursecancellationStatuss"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>


<!-- 
              <el-form-item label="日期:" style="display: flex;width: 60%; padding-left: 27px;">
                <el-date-picker
                style="width: 100%;"
                v-model="dateTimeList"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
                </el-date-picker>
              </el-form-item> -->

       </el-form>


       <div style="display: flex;margin-bottom: 30px;">
              <div style="width: 70%;display: flex;">
                <div style="width: 50%;">
                  <div style="text-align: start; margin-bottom: 7px;">复核内容：</div>
                  <div class="box">
                     <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                      <div>老师：{{ itme.commitContent }}</div>
                      <div>审核人：{{ itme.auditContent }}</div>
                     </div>
                  </div>
                </div>
                <div style="width: 50%;margin-left: 10px;">
                  <div style="text-align: start; margin-bottom: 7px;">复核建议：</div>
                  <div>
                     <el-input resize="none"  type="textarea" :disabled="notarizeType != 3" :autosize="{  minRows: 6, maxRows: 6 }"  v-model="textareass"> </el-input>
                  </div>
                  <div>
                    <i class="el-icon-circle-check" v-if="notarizeType === 3" style="color: #1ad70c;position: absolute; font-size: 25px; margin-top: -30px;margin-left: 157px;" @click="handleClick"></i>
                  </div> 
                </div>
              </div>
              <div style="display: flex;justify-content: end;margin-top: 10px;margin-bottom: 30px;margin-left: 20px;width: 28%;">
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>
       </div>

      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }" :cell-style="{'text-align':'center'}" :data="dataList" border height="250">
        <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseStartTime" label="开始时间"></el-table-column>
        <el-table-column prop="courseEndTime" label="结束时间"></el-table-column>
        <el-table-column prop="subjectName" label="课程"></el-table-column>
        <el-table-column prop="educationType" label="上课方式">
          <template slot-scope="scope">
              <span v-if="scope.row.educationType === 2 ">上门</span>
              <span v-if="scope.row.educationType === 1 ">网课</span>
              <span v-if="scope.row.educationType === 3 ">门店</span>
          </template>
        </el-table-column>
        <el-table-column prop="studentName" label="学员"></el-table-column>
        <el-table-column prop="isSales" label="课消状态">
          <template slot-scope="scope">
              <span v-if="scope.row.isSales == 0 ">未课消</span>
              <span v-else-if="scope.row.isSales == 1 ">已课消</span>
              <span v-else>全部</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesNum" label="课消次数"></el-table-column>

      </el-table>



      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>


     </el-card>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";

import { ExportExcel, ExportApiExcel } from "../utils/Export"



import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../pinia/stores.js'
import { storeToRefs } from 'pinia';



import {
  getTeachers,
  getStudents
} from "@/api/firstClassApi";


import { getSubject } from "@/api/fiveClassApi"

import {  getStudentsType } from "@/api/fiveClassApi"
export default defineComponent({
  props: {
    DetailsRow: Object,
    TimeList: Array,
    // isNewClassType:Number,
  },
  setup(props, { attrs, slots, emit, expose  }){
    const coursecancellationStatus = reactive([{ id: '', realname: '全部'},{ id: 0, realname: '未课消'},{ id: 1, realname: '已课消'}])
    const coursecancellationStatuss = reactive([{ id: 2, realname: '上门'},{ id: 1, realname: '网课'},{ id: 3, realname: '门店'},])
    let coursecancellationStatusInput = ref('')
    let coursecancellationStatusInputs = ref('')
    let dataTop_s = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let requestParameters = reactive({ pageSize: 10,  pageNum: 1, total: 0, })
    let dataList = ref([])
    let curriculumArr = ref([])

    let getStudentsArr = ref([])
    let getStudentsArr_s = ref([])

    let dateTimeList = ref([])
    let TimeList = ref([])
    let student = ref("")
    let student_s = ref("")
    let curriculum = ref("")
    let teacherId = ref("")

    let textareas = ref("")
    let textareass = ref("")

    let optionList4 = ref([])


    let isShowType = ref(true)


    let newClassType =  ref('')
    let newClassTypeList = ref([
      { id:1, name:'规划'},
      { id:2, name:'线下'},
      { id:3, name:'纯补课'},
    ])
    
    const store = useStore()
    // const { teacherName } = storeToRefs(store.row)
    const rowObj = storeToRefs(store.row)


    let doubtContent = ref([])
    let notarizeType = ref('')

    onMounted(()=>{


      getSubject().then(res => {  optionList4.value = res.data })


       axios.post(`${apiBaseUrl}/student/getStudentList`, { studentType: 2, },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
          let { data } = res;
          if (data.code == 200) {
             getStudentsArr.value = data.data
          }
       });
       // 线下学生 studentType：2
       axios.post(`${apiBaseUrl}/student/getStudentList`, { studentType: 1, },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
          let { data } = res;
          console.log(data)
          if (data.code == 200) {
             getStudentsArr_s.value = data.data
          }
       });

      console.log('props',rowObj)

      doubtContent.value = rowObj.doubtContent.value ? JSON.parse(rowObj.doubtContent.value) : []
      notarizeType.value = rowObj.notarizeType.value

    //   TimeList.value = props.TimeList

    //   newClassType.value = props.isNewClassType

    //   teacherId.value = rowObj.teacherId.value

    //   handleSelectAll()

     if(TimeList.value){
        dateTimeList.value = TimeList.value
        let data = {
           id: rowObj.id.value,                                        //必传 列表id
           pageNum: requestParameters.pageNum,                         //第几页 必传
           pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: '',                               //课程id 非必传
           educationType: '',        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: '',                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: '',                                             //线下学员跟规划学员总和 用逗号分隔 非必传  
        }

        getListData(data)
     }else{
        let data = {
           id: rowObj.id.value,                                        //必传 列表id
           pageNum: requestParameters.pageNum,                         //第几页 必传
           pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: '',                               //课程id 非必传
           educationType: '',        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: '',                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: '',                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }

        getListData(data)
     }

    })


    const handleSelectAll = () =>{

     axios.get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
        curriculumArr.value = response.data.data
     }).catch(error => { console.error(error)})
    //  getStudentsType(2).then((res) => {  getStudentsArr.value = res.data })
    //  getStudentsType(1).then((res) => {  getStudentsArr_s.value = res.data })
    }

    const exportBtns = () => {
      // const data = [
      //   ["姓名", "年龄", "职业"],
      //   ["Alice", 28, "Engineer"],
      //   ["Bob", 22, "Designer"]
      // ];
      // ExportExcel(data)

      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }


      let data = {
           id: rowObj.id.value,                                        //必传 列表id
          //  pageNum: requestParameters.pageNum,                         //第几页 必传
          //  pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: curriculum.value,                               //课程id 非必传
           educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: str,                                             //线下学员跟规划学员总和 用逗号分隔 非必传
      }


      axios.post(`${apiBaseUrl}/teacherHourAudit/exportInfo`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
        if(response.status == 200){
           const blob = new Blob([response.data], { type: "application/vnd.ms-excel",});
           const downloadLink = document.createElement("a");
           downloadLink.href = URL.createObjectURL(blob);
           downloadLink.download = "课消详情统计.xlsx";
           downloadLink.click();
           handleMessage('导出成功', 'success')
        }else{
           handleMessage('导出失败', 'error')
        }
      })

    }

    const searchBtns = () =>{
      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }

      if(dateTimeList.value){
        let data = {
           id: rowObj.id.value,                                        //必传 列表id
           pageNum: requestParameters.pageNum,                         //第几页 必传
           pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: curriculum.value,                               //课程id 非必传
           educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: str,                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }
        getListData(data)
      }else{
        let data = {
           id: rowObj.id.value,                                        //必传 列表id
           pageNum: requestParameters.pageNum,                         //第几页 必传
           pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: curriculum.value,                               //课程id 非必传
           educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: str,                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }
        getListData(data)
      }
    }

    const clearBtns = () =>{
      // dateTimeList.value = []
      curriculum.value = ""
      student.value  = ""
      student_s.value  = ""
      coursecancellationStatusInput.value = ""
      newClassType.value = ""
      requestParameters.pageNum = 1
      requestParameters.pageSize = 10
      
      if(dateTimeList.value){
        let data = {
          id: rowObj.id.value,                                        //必传 列表id
          pageNum: requestParameters.pageNum,                         //第几页 必传
          pageSize: requestParameters.pageSize,                       //每页几条 必传
          categoryId: curriculum.value,                               //课程id 非必传
          educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
          classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
          studentIds: '',                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }

        getListData(data)
      }else{
        let data = {
           id: rowObj.id.value,                                        //必传 列表id
           pageNum: requestParameters.pageNum,                         //第几页 必传
           pageSize: requestParameters.pageSize,                       //每页几条 必传
           categoryId: curriculum.value,                               //课程id 非必传
           educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
           classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
           studentIds: '',                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }

        getListData(data)
      }
    }


    const getListData = (data) =>{

      axios.post(`${apiBaseUrl}/teacherHourAudit/queryClassSalesTeacherInfo`, data,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {

        let list = response.data
        if (list.code == 200) {
              requestParameters.total = list.data.total
              requestParameters.pageNum = list.data.current
              requestParameters.pageSize = list.data.size
              dataList.value = list.data.records

              // dataTop_s.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
              // dataTop_s.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
              // dataTop_s.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
              // dataTop_s.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
              // dataTop_s.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
              // dataTop_s.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0

              handleMessage('课消详情查询成功', 'success')
          }else{
              handleMessage('课消详情查询失败', 'error')
        }
        })
        .catch(error => {
          handleMessage('查询失败','error')
          console.error(error);
        });
    }

    const handleSizeChange = (pageSize) => {

      requestParameters.pageSize = pageSize;


      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }

      let data = {
          id: rowObj.id.value,                                        //必传 列表id
          pageNum: requestParameters.pageNum,                         //第几页 必传
          pageSize: requestParameters.pageSize,                       //每页几条 必传
          categoryId: curriculum.value,                               //课程id 非必传
          educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
          classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
          studentIds: str,                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }

      getListData(data);
    }

    const handleCurrentChange  = (newPage) => {
      requestParameters.pageNum = newPage;


      let str = ""
      if(student.value){
        str = student.value + ''
        if(student_s.value){
          str =  student.value + ',' + student_s.value
        }
      }else{
        if(student_s.value){
          str = student_s.value  + ''
        }
      }

      let data = {
          id: rowObj.id.value,                                        //必传 列表id
          pageNum: requestParameters.pageNum,                         //第几页 必传
          pageSize: requestParameters.pageSize,                       //每页几条 必传
          categoryId: curriculum.value,                               //课程id 非必传
          educationType: coursecancellationStatusInputs.value,        //上课方式 1：网课；2：上门; 3门店 非必传
          classType: newClassType.value,                              //学生类型：1：规划、2：线下、3：纯补课 非必传
          studentIds: str,                                             //线下学员跟规划学员总和 用逗号分隔 非必传
        }


      getListData(data);
    }

    const handleMessage = (message,type) =>{
       $Vue.$message({ message, type, duration: 500 });
    }


    const handleReturn = () =>{
       emit('handleEmitButs', false, 'bomm')
    }


    const handleClick = () =>{
    
      let len = doubtContent.value.length
      doubtContent.value[len - 1].auditContent = textareass.value 

      let data = {
        id: rowObj.id.value,
        doubtContent: JSON.stringify(doubtContent.value),
      }

      axios.post(`${apiBaseUrl}/teacherHourAudit/audit`, data,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        if(response.data.code == 200){
          handleMessage('复核建议提交成功！', 'success')
          isShowType.value = false
        }else{
          handleMessage('复核建议提交失败！', 'error')
        }
      }).catch(error => { 
        handleMessage(error, 'error')
        console.error(error)
      })
    }


    return {
      curriculumArr,
      getStudentsArr,
      getStudentsArr_s,
      dateTimeList,
      curriculum,
      student,
      student_s,
      dataList,
      requestParameters,
      coursecancellationStatuss,
      coursecancellationStatusInputs,
      textareas,
      textareass,


      handleSelectAll,
      exportBtns,
      searchBtns,
      getListData,
      handleSizeChange,
      handleCurrentChange,
      handleMessage,
      handleReturn,
      clearBtns,
      dataTop_s,
      coursecancellationStatus,
      coursecancellationStatusInput,

      newClassTypeList,
      handleClick,
      newClassType,

      doubtContent,
      notarizeType,
      optionList4,

    }
  },

})

</script>

<style scoped >

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
.el-form-item__label{
  width: 100px;
}


.box{
    text-align: start;
    padding-left: 10px;
    height: 126px;
    overflow-y: auto;
    border: 1px solid #dcd5d5;
    border-radius: 9px;
    padding-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/TeacherClassApproval/CourseSalesStatisticsDetails.vue